// ** MUI Imports
import { Theme } from '@mui/material/styles'

const Rating = (theme: Theme) => {
  return {
    MuiRating: {
      styleOverrides: {
        root: {
          color: theme.palette.warning.main
        },
        iconEmpty: {
          color: theme.palette.customColors.main.replace(')', ', 0.22)')
        }
      }
    }
  }
}

export default Rating
